import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

const createProjectSchemaValidation = yup.object().shape({
  name: yup.string().required("Nome do projeto obrigatório")
});

export const createProjectValidationResolver = yupResolver(createProjectSchemaValidation);
